import { InsuranceVerificationAdapterService } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/v2/insurance_verification_adapter.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaInsuranceVerificationAdapterV2Service = bindHTTP(InsuranceVerificationAdapterService);
export const serviceName = 'insurance-verification-adapter-v2' as const;
